import { useEffect, useState } from 'react'
import React from 'react'
import { useLocation } from '@reach/router'
import $ from 'jquery'
import useQueryProperties from '@hooks/useQueryProperties'
import { RealEstateDataPageComponentData, StatePropertiesSlice } from 'types'
import { useDispatch, useSelector } from 'react-redux'
import { updateOffsetAction } from '@slices/propertiesSlice'

const PaginatedItems = ({
  global_data,
  viewId,
}: RealEstateDataPageComponentData & { viewId: number }) => {
  const { offset, filters, polygonCoordinates, coordinates, orders } = useSelector(
    (state: { properties: StatePropertiesSlice }) => state.properties,
  )!

  const dispatch = useDispatch()
  const itemsPerPage = 50
  const [currentPage, setCurrentPage] = useState(offset / itemsPerPage)
  const [items, setItems] = useState([0, 1, 2])
  const [fixed, setFixed] = useState(false)
  const API_KEY = global_data.pageConfig.keys.tokko
  const {
    properties,
    isLoading: isLoadingProperties,
    isFetching: isFetchingProperties,
  } = useQueryProperties({
    filters,
    coordinates,
    polygonCoordinates,
    orders,
    offset,
    tokkoKey: API_KEY,
  })
  // const { data: properties, isLoading: isLoadingProperties, isFetching: isFetchingProperties } = useGetPropertiesQuery({
  //   "API_KEY":realEstate.keys.tokko,
  //   "params_get":makeParamsGetByFilters(orders,offset,polygonCoordinates) + makeFormDataByFilters(filters,coordinates,polygonCoordinates),
  //   "body":makeParamsCoordinates(coordinates,polygonCoordinates)
  // });

  const location = useLocation()

  const getItems = (data: any) => {
    let items: any = []
    if (properties?.objects?.length! > 50) {
      return items
    }
    for (let index = 0; index < Math.ceil(data / itemsPerPage); index++) {
      items.push(index)
    }
    return items
  }

  useEffect(() => {
    setItems(getItems(properties?.meta?.total_count))
    if (properties?.meta?.total_count > 0) {
      setFixed(true)
    }
    if (offset === 0) {
      setCurrentPage(0)
    }
  }, [offset, properties?.meta?.total_count])

  useEffect(() => {
    dispatch(updateOffsetAction(currentPage * itemsPerPage))
    // if(location.pathname.includes(filters.operation.toLowerCase())){
    // dispatch(getPropertiesAction())
    // }
  }, [currentPage])

  return (
    items.length > 1 && (
      <>
        <div
          className={`mt-4 pt-0 pagination d-flex align-items-center flex-column justify-content-center ${
            viewId == 1 ? 'only-map' : ''
          }`}
        >
          {!fixed ? null : (
            <>
              <div
                id="paginator"
                className="d-flex align-items-center justify-content-center"
              >
                {/* <div onClick={() => setCurrentPage( ? items[items.length-1] : currentPage-1)} className={"cursor-pointer pagination-item d-flex justify-content-center align-items-center " + (currentPage === 0 ? 'opacity-disabled' : '')}> */}
                <div
                  onClick={() => {
                    $('html, body').animate({ scrollTop: 0 }, 'slow')
                    items[0] !== currentPage ? setCurrentPage(currentPage - 1) : ''
                  }}
                  className={
                    'cursor-pointer arrow-item pagination-item d-flex justify-content-center align-items-center ' +
                    (currentPage === 0 ? 'opacity-disabled' : '')
                  }
                >
                  {''}
                </div>
                <div className="container-pagination d-flex align-items-center">
                  {/* <div className={"item-paginate points  " + (currentPage > (items[0]+1) ? '' : ' opacity ')}>
                            ...
                        </div> */}
                  <div
                    className={
                      'item-paginate opacity ' + (currentPage === items[0] ? '' : ' d-none ')
                    }
                  >
                    0-000
                  </div>
                  {items.map((item, index) => (
                    <div
                      key={index}
                      onClick={() => {
                        $('html, body').animate({ scrollTop: 0 }, 'slow')
                        setCurrentPage(item)
                      }}
                      className={
                        'item-paginate ' +
                        (item === currentPage && ' active') +
                        (currentPage === item ||
                        currentPage === item + 1 ||
                        currentPage === item - 1
                          ? ''
                          : ' d-none ')
                      }
                    >
                      {item > 0 ? item * itemsPerPage + 1 : item * itemsPerPage} a{' '}
                      {(item + 1) * itemsPerPage > properties?.meta?.total_count
                        ? properties?.meta?.total_count
                        : (item + 1) * itemsPerPage}
                    </div>
                  ))}
                  <div
                    className={
                      'item-paginate opacity ' +
                      (currentPage === items[items.length - 1] ? '' : ' d-none ')
                    }
                  >
                    0-000
                  </div>
                  {/* <div className={"item-paginate points end  " + (currentPage < (items[items.length-1]-1) ? '' : ' opacity ')}>
                            ...
                        </div> */}
                </div>
                <div
                  onClick={() => {
                    $('html, body').animate({ scrollTop: 0 }, 'slow')
                    items[items.length - 1] !== currentPage ? setCurrentPage(currentPage + 1) : ''
                  }}
                  className={
                    'cursor-pointer arrow-item next pagination-item d-flex justify-content-center align-items-center ' +
                    (currentPage === items[items.length - 1] ? 'opacity-disabled' : '')
                  }
                >
                  {''}
                </div>
              </div>
              <h5 className="text-uppercase d-block mt-lg-2 mt-1">
                {isLoadingProperties || isFetchingProperties ? (
                  'Cargando resultados..'
                ) : (
                  <>
                    <strong> {properties?.meta?.total_count} </strong> de{' '}
                    <strong>
                      {filters.operation === 'venta'
                        ? properties?.meta?.total_count
                        : properties?.meta?.total_count}
                    </strong>{' '}
                    propiedades en {filters.operation}
                  </>
                )}
              </h5>
            </>
          )}
        </div>
      </>
    )
  )
}

export default PaginatedItems
